interface TimeAxisProps {
  slots: string[];
  slotHeightPx: number;
}

export function TimeAxis({ slots, slotHeightPx }: TimeAxisProps) {
  return (
    <div
      className="relative bg-biz-surface border-r border-biz-border"
      style={{ height: slots.length * slotHeightPx }}
      aria-hidden="true"
    >
      {slots.map((s, i) => {
        const isHour = s.endsWith(':00');
        return (
          <div
            key={s}
            className="absolute left-0 right-0 flex items-start justify-end pr-2"
            style={{ top: i * slotHeightPx, height: slotHeightPx }}
          >
            {isHour && (
              <span className="font-mono-num text-[11px] font-medium text-biz-foreground-muted -translate-y-1.5">
                {s}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
